import { createWebHistory, createRouter } from "vue-router";
import Welcome from "@/pages/WelcomeScreen.vue";
import Home from "@/pages/Home.vue";
import Schedule from "@/pages/ScheduleList.vue";
import ScheduleBack from "@/pages/ScheduleListBack.vue";
import ChooseSeat from "@/pages/ChooseSeat.vue";
import ChooseSeatBack from "@/pages/ChooseSeatBack.vue";
import PassengerInfo from "@/pages/PassengerInfo.vue";
import PaymentCart from "@/pages/PaymentCart.vue";
import PaymentSuccess from "@/pages/PaymentSuccess.vue";
import ShowTicket from "@/pages/ShowTicket.vue";
import TicketBooking from "@/pages/TicketBooking.vue";
import NotFound from "@/pages/NotFound.vue";

const routes = [
  {
    path: "/",
    name: "welcome",
    component: Welcome,
  },
  {
    path: "/Home",
    name: "Home",
    component: Home,
  },
  {
    path: "/schedule-list",
    name: "schedule-list",
    component: Schedule
  },
  {
    path: "/schedule-list-back",
    name: "schedule-list-back",
    component: ScheduleBack
  },
  {
    path: "/choose-seat",
    name: "choose-seat",
    component: ChooseSeat
  },
  {
    path: "/choose-seat-back",
    name: "choose-seat-back",
    component: ChooseSeatBack
  },
  {
    path: "/passenger-info",
    name: "passenger-info",
    component: PassengerInfo
  },
  {
    path: "/payment-cart",
    name: "payment-cart",
    component: PaymentCart,
  },
  {
    path: "/payment-success",
    name: "payment-success",
    component: PaymentSuccess,
  },
  {
    path: "/show-ticket",
    name: "show-ticket",
    component: ShowTicket,
  },
  {
    path: "/ticket-booking",
    name: "ticket-booking",
    component: TicketBooking,
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory("/#/"),
  routes,
});

export default router;
